export const cacheTime = 1000 * 60 * 60
export const logoutTime = 1000 * 60 * 60;
export const modalStyleIFrame = { title: null, footer: null, width: "95%", bodyStyle: { padding: 0, lineHeight: 0 } }
export const modalStyleForm = { width: "95%" }

